<app-dropdown-select
  [options]="filteredCurrencies"
  [selectedOption]="currency"
  [label]="label"
  [isEnabled]="!disabled"
  (optionSelected)="currencySelected($event)"
  [isRequired]="isRequired"
  [customShadowClass]="customShadowClass"
  [panelRadius]="panelRadius"
  [detachPanel]="detachPanel"
  [showGradientBorder]="false"
>
</app-dropdown-select>
